import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import { getApiHeader } from 'utlis/commonfunctions';
import DropIn from 'braintree-web-drop-in-react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import ActivationHead from './ActivationHead';
import Loader from "./loader";







function AccountCheck({ nextStep, prevStep, commonSession, retailerDetails, getValidationStatus, getUserEmail,setStep }) {
    const sessionId = commonSession;
    const SERVER_URL = process.env.REACT_APP_API_URL
    const [checkBoxStatus, setCheckBoxStatus] = useState("")
    const [loading, setLoading] = useState(false);

    const [selected, setSelected] = useState(true)
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        password_confirm: "",
        cemail: ""
    });


    const [passWordError, setPassWordError] = useState(null);
    const [verified_email, setVerified_email] = useState(false);

    const myaccount_display = retailerDetails?.myaccount_display;
    const otp_verification_status = retailerDetails?.otp_verification_email;


    const handleChange = (event) => {
        const { name, value } = event.target
        if (name === "email") {
            getUserEmail(value)
            setFormData((prevData) => ({
                ...prevData,
                email: value,

            }))
        }

        else if (name === "cemail") {
            setFormData((prevData) => ({
                ...prevData,
                cemail: value,

            }))
        }

        else if (name === "password") {
            setFormData((prevData) => ({
                ...prevData,
                password: value,
            }))
        } else if (name === "confirm-password") {
            if (password != value) {
                setPassWordError(true)
            } else {
                setPassWordError(false)
            }
            setFormData((prevData) => ({
                ...prevData,
                password_confirm: value,
            }))

        }
    }




    useEffect(() => {
        if (otp_verification_status === false && myaccount_display === true) { setVerified_email(true) }
        handleGetNumber();
        // if(myaccount_display === true){
        //     handleClientToken();
        // }

    }, [])




    const handleGetNumber = async () => {

        if (myaccount_display === false) {
            setSelected(false);
        }


        try {
            const header = await getApiHeader()
            const params = new URLSearchParams();
            params.append(sessionId);
            const response = await axios.get(`${SERVER_URL}activation/create/account?${params.toString()}`, { headers: header });

            if (response.status === 200) {
                setCheckBoxStatus(response?.data?.data.register_my_account_check_box_status)
            }

        } catch (error) {

        }

    }




        const handleSendOtp = async (event) => {
        event.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)){
            swal("", "Please enter a valid username", 'warning');
            return ;
        }
    
       setLoading(true);

        const post_data = {
            session_id: commonSession,
            username: formData.email,
        };

        const headers=await getApiHeader();

        try {
            const response = await axios.post(`${SERVER_URL}postpaid-activation/verify_username`, post_data, { headers });
            var response_error = true;


            if(response.status===200){
                                
                if(response?.data?.data?.id_verification===true){
                    nextStep()
                    getValidationStatus(true)
                    setLoading(false);
                
                }else{
                    setStep(7)
                    setLoading(false);
                    getValidationStatus(false)


                }

              if(response.data.message !== 'undefined'){
                    //swal(response.data.message, "", 'success');
                    if(response?.data?.data?.SessionId !== 'undefined'){
                    var SessionId = response?.data?.data?.SessionId;
                    var response_error = false;
                    setLoading(false);
                    // handleSession(SessionId);
                    // handleAccountCheck(response.data.data.accountData);
                    // nextStep();
                    // setStep(7)
                  }
              }
              setLoading(false);
          }
        //   if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }

        } catch (error) {
            setLoading(false);
               console.log("error=======>",error)
            setLoading(false);
            if(error?.response?.data?.message != 'undefined'){
                swal("", error?.response?.data?.message, 'warning');
            }else{
                swal("Unexpected error", "Please try again", 'error');
            }
            
        }
    };


    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                        {loading === true && (
                            <Loader />
                        )}

                   
                            <h6> Verify Email Address</h6>
                      
                        <hr />
                        <br />
                         <p className='plans-notes'>Note: If you already have a Telsim My Account user ID, please enter it. Otherwise, please enter your email address.</p>
                        <form className="add-plan-form create-account">

                            <div className="makeflex mob-dis-blok">

                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 fullwidth-nopad">
                                    <label className="formbold-form-label formbold-form-label-2">Email Address <span className="madate_mark">*</span></label>

                                        <input
                                            autoComplete="new-password"
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Enter email"
                                            maxLength="60"
                                            className="formbold-form-input"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                       


                                </div>


                            </div>



                            <br />
                            <br />
                            <br />
                            <br />

                            <div className="button-container activationBlock-button-container">
                                <button type="button" onClick={prevStep} className="button btn btn-danger">
                                    Back
                                </button>


                              
                                    <>

                                        <button onClick={handleSendOtp}  className="button btn btn-danger ad-mb-button-next">
                                            Click to Continue
                                        </button>

                                    </>
               
                            </div>

                        </form>





                    </div>
                </div>
            </DashboardLayout>
        </div>
    )
}

export default AccountCheck